import * as Yup from 'yup'

import { SEPARATOR_PATTERN } from '../components/branchesPanel/branchesTree/helpers'

Yup.addMethod(Yup.string, 'noSeparatorIssues', function (message: string) {
  return this.test(
    'noSeparatorIssues',
    message,
    (value?: string) =>
      !value ||
      (!SEPARATOR_PATTERN.test(value[0]) &&
        !SEPARATOR_PATTERN.test(value[value.length - 1]) &&
        !new RegExp(`${SEPARATOR_PATTERN.source}{2}`).test(value)),
  )
})

Yup.addMethod(Yup.string, 'noSpaces', function (message: string) {
  return this.test(
    'noSpaces',
    message,
    (value?: string) => !!value && !/\s/.test(value),
  )
})

Yup.addMethod(
  Yup.string,
  'notForbidden',
  function (message: string, forbidden: string[]) {
    return this.test(
      'notForbidden',
      message,
      (value?: string) => !value || !forbidden.includes(value),
    )
  },
)

Yup.addMethod(
  Yup.string,
  'notDuplicated',
  function (message: string, otherValues: string[]) {
    return this.test(
      'notDuplicated',
      message,
      (value?: string) => !value || !otherValues.includes(value),
    )
  },
)

Yup.addMethod(Yup.object, 'isNull', function (message: string) {
  return this.test('isNull', message, (value) => !value)
})
